<script>
export default {
  name: 'TwButtonBadge',
  props: {
    variant: {
      type: String,
      required: false,
      default: 'gray'
    },
    size: {
      type: String,
      default: null,
    }
  },
  computed: {
    variantClasses() {
      return `bg-${this.variant}-100 text-${this.variant}-800 border-${this.variant}-400`;
    },
    sizeClasses() {
      switch(this.size) {
      case 'sm':
        return 'px-1 py-0 text-xxs -my-0.5';
      case 'lg':
        return 'px-2.5 py-1 text-sm -my-0.5 font-bold';
      default:
        return 'px-1 py-0 text-xs -my-0.5';
      }
    },
    classes() {
      return `${this.variantClasses} ${this.sizeClasses}`;
    }
  }
}
</script>

<template>
  <span :class="'inline-flex items-center rounded-full border-2 border-solid ' + classes"><slot /></span>
</template>

<style scoped>

</style>
